import { useLocalizedFields } from "@/shared/form/localized-value/model/localized-field";
import Form, { Rule } from "@/shared/form/form";
import Input from "@/shared/form/input";
import { Fragment } from "react";

type HiddenFieldsProps = {
  name: string | string[];
  htmlRules?: Rule[];
};

export function HiddenFields({ name, htmlRules }: HiddenFieldsProps) {
  const { languages, localeToControlName } = useLocalizedFields();

  return languages?.map((locale) => {
    const fieldName = localeToControlName(locale);

    const templateDataName = [
      ...(Array.isArray(name) ? name : [name]),
      "templateData",
      fieldName,
    ];

    const htmlName = [
      ...(Array.isArray(name) ? name : [name]),
      "html",
      fieldName,
    ];

    return (
      <Fragment key={fieldName}>
        <Form.Item name={templateDataName} hidden>
          <Input />
        </Form.Item>

        <Form.Item name={htmlName} rules={htmlRules} hidden>
          <Input />
        </Form.Item>
      </Fragment>
    );
  });
}
